import AgencyService from 'services/agenciesService'
import { ListingAgreementSettings } from 'types/agencySettings'

const getListingAgreementSettings = async (
  getAuthToken: () => Promise<string>,
  agencyId?: string
): Promise<ListingAgreementSettings | undefined> => {
  if (!agencyId) return

  const token = await getAuthToken()
  const service = new AgencyService(token)

  

  const result = await service.agencyService.get(
    'GetListingAgreementSettings',
    {
      agencyId,
    }
  )

  return result.data
}

export default getListingAgreementSettings
